import { ALPHA_2_ISO_3166 } from 'cpool-constants';
import { z } from 'zod';

export const Anschrift = z.object({
    hausnummer: z.string().nullish().default(null),
    land: z.nativeEnum(ALPHA_2_ISO_3166).nullish().default(null),
    ort: z.string().nullish().default(null),
    plz: z.string().nullish().default(null),
    strasse: z.string().nullish().default(null),
    wohnhaftSeit: z.coerce.date().nullish().default(null),
});

export type Schema_Anschrift = z.infer<typeof Anschrift>;

/*

const anschriftSchema = yup
    .object()
    .shape({
        hausnummer: yup.string().optional().nullable().default(null),
        land: yup
            .string()
            .oneOf([])
            .optional()
            .nullable()
            .default(null),
        ort: yup.string().optional().nullable().default(null),
        plz: yup.string().optional().nullable().default(null),
        strasse: yup.string().optional().nullable().default(null),
        wohnhaftSeit: yup.date().optional().nullable().default(null),
    })
    .optional();
	*/
